import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader, getCurrentYear } from "../Helpers";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import logo from '../assets/logo_icon.png';

export default function Footer(props) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    // any initialization logic here
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready)
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;

  return (
    <div
      className="MainBodySection bg-primary"
      style={{
        paddingBottom: "50px",
        paddingTop: "50px",
        borderTop: "1px solid var(--secondaryColor)",
      }}
    >
      <div className="container">
        <div className="row">
          {/* Quick Links */}
          <div className="col-md-4 mb-4">
            <h6 className="main-section-title text-start">Quick Links</h6>
            {[
              { name: "Home", item: "" },
              { name: "About Us", item: "about_us" },
              { name: "Programs", item: "programs" },
              { name: "Contact", item: "contact_us" },
              { name: "Donate", item: "donations" }
            ].map((link, i) => (
              <h6
                key={i}
                style={{
                  fontSize: "14px",
                  padding: "10px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  appContext.navTo({ item: link.item });
                }}
                className="font-bold text-light"
              >
                {link.name}
              </h6>
            ))}

          </div>

          {/* Address */}
          <div className="col-md-4 mb-4">
            <h6 className="main-section-title text-start">Address</h6>
            <h6
              style={{
                fontSize: "14px",
                padding: "10px",
              }}
              className="font-bold text-light"
            >
              MBEYA TANZANIA
            </h6>
          </div>

          {/* Contact */}
          <div className="col-md-4 mb-4">
            <h6 className="main-section-title text-start">Reach Out</h6>
            <h6
              style={{
                fontSize: "14px",
                padding: "10px",
              }}
              className="font-bold text-light"
            >
              Email: <span>info@tachi.or.tz</span> <br />
              Phone: <span>+255 697 310 310 / +255 749 024 050</span>
            </h6>
          </div>

          {/* Footer Bottom */}
          <div className="col-md-12 text-center font-bold">
            <hr />
            <h6
              style={{
                fontSize: "14px",
                paddingTop: "20px",
              }}
              className="text-light"
            >
              &copy; Tanzania Children Hope Innovation TCHI - {getCurrentYear()}. All rights reserved.
            </h6>

            <h6
              style={{
                fontSize: "14px",
                paddingTop: "10px",
              }}
              className="text-light"
            >
              Website Developed By{" "}
              <a target="_blank" href="https://werenium.com">
                Werenium Technologies
              </a>
            </h6>
          </div>
        </div>
      </div>
    </div>
  );
}
